import type { DraftValidationDetail } from "../../api/queries/adminQueries";
import { sanitizeEmailHtml } from "../../utils/sanitizeEmailHtml";

type ThreadContextPanelProps = {
  detail: DraftValidationDetail;
  formatDate: (iso: string) => string;
};

export const ThreadContextPanel = ({
  detail,
  formatDate,
}: ThreadContextPanelProps) => (
  <>
    <div>
      <h3 className="mb-2 text-sm font-semibold text-slate-700">
        Thread State Facts
      </h3>
      <pre className="whitespace-pre-wrap rounded-lg border border-slate-200 bg-slate-50 p-4 font-mono text-xs text-slate-600">
        {detail.thread_state_facts || "No thread state available."}
      </pre>
    </div>

    <div>
      <h3 className="mb-2 text-sm font-semibold text-slate-700">
        Latest Message (Triggered Draft)
      </h3>
      {detail.latest_message ? (
        <div className="space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-4">
          <div className="space-y-1 text-xs text-slate-600">
            <div>
              <span className="font-medium">From:</span>{" "}
              {detail.latest_message.from_name
                ? `${detail.latest_message.from_name} <${detail.latest_message.from_email}>`
                : detail.latest_message.from_email}
            </div>
            <div>
              <span className="font-medium">Subject:</span>{" "}
              {detail.latest_message.subject}
            </div>
            <div>
              <span className="font-medium">Date:</span>{" "}
              {formatDate(detail.latest_message.date_sent)}
            </div>
          </div>
          <div
            className="border-t border-slate-200 pt-2 text-sm text-slate-900"
            dangerouslySetInnerHTML={{
              __html: sanitizeEmailHtml(detail.latest_message.text || ""),
            }}
          />
        </div>
      ) : (
        <p className="rounded-lg border border-dashed border-slate-300 bg-slate-50 p-4 text-sm italic text-slate-600">
          No latest triggering message was found for this draft.
        </p>
      )}
    </div>
  </>
);
